/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import { action } from '@ember/object';
import Component from '@glimmer/component';
import { TYPES, NAMES, SYNC_STATUSES, AdNetworkType, AdNetworkStatus } from 'cio/utils/ad-audiences';

interface AudienceFilterArgs {
  types: string[];
  statuses: string[];
  onStatusUpdate: (statuses: string[]) => void;
  onTypeUpdate: (types: string[]) => void;
}

export default class AudiencesFilter extends Component<AudienceFilterArgs> {
  readonly NAMES = NAMES;
  readonly types: AdNetworkType[] = [TYPES.adwords, TYPES.facebook];
  readonly statuses: typeof SYNC_STATUSES = SYNC_STATUSES;

  @action
  didChangeType(type: AdNetworkType, checked: boolean) {
    if (checked) {
      this.args.onTypeUpdate([...this.args.types, type]);
    } else {
      this.args.onTypeUpdate(this.args.types.without(type));
    }
  }

  @action
  didChangeStatus(status: AdNetworkStatus, checked: boolean) {
    if (checked) {
      this.args.onStatusUpdate([...this.args.statuses, status]);
    } else {
      this.args.onStatusUpdate(this.args.statuses.without(status));
    }
  }
}
